import * as React from "react";
import { Product } from "typings/index";
import { 
    Dialog,
    PrimaryButton, 
    DialogFooter, 
    DefaultButton, 
    TextField, 
    SelectionMode, 
    DetailsList, 
    CheckboxVisibility, 
    IColumn, 
    Selection 
} from "office-ui-fabric-react/lib";
import API from "../../../../services/api";
import { getProductName } from "~/util/productHelper";

export interface Props
{
    selectedProducts: string[];
    hideDialog: () => void;
    onSave: (selectedProduct: string[]) => void;
}


let timer: NodeJS.Timeout;
const ProductPicker: React.FunctionComponent<Props> = props =>
{
    const [products, setProducts] = React.useState<Product[]>([]);
    const [selectedProducts, setSelectedProduct] =  React.useState<string[]>(props.selectedProducts);

    const onSearchChange = (event: any, value: string) =>
    {
        clearTimeout(timer);
        timer = setTimeout(async () => 
        {
            if (value.length > 2)
            {
                const result = await API.product.fetchProducts({term: value, page: 0, showVariants: true, showMainProducts: true});
                setProducts(result.products);
            }
        }, 400);
    };

    const onSave = () =>
    {
        props.onSave(selectedProducts.filter((value, index, self) =>  self.indexOf(value) === index));
    };

    const onSelectionChanged = () =>
    {
        const selected: Product[] = selection.getSelection();
        setSelectedProduct([...selectedProducts, ...selected.map(x => x.id )]);
     
    };

    const selection: any = new Selection({ 
        onSelectionChanged,
        
    });

    const columns: IColumn[] = [
        { key: "column1", name: "sku", fieldName: "item.data.sku.value", minWidth: 50, maxWidth:150, isResizable: true,
            onRender: (item: Product) => 
            {
                return <span>{item.data.sku.value}</span>;
            },

        },
        { key: "column2", name: "name", fieldName: "data.itemName.value", minWidth: 350, isResizable: true,
        onRender: (item: Product) => 
        {
            const title = getProductName(item);
            return <span>{title}</span>;
        },
        
    }

    ];

    return (
        <Dialog hidden={false} onDismiss={props.hideDialog} minWidth={650}>
           <TextField onChange={onSearchChange} placeholder="Search"></TextField>
           <DetailsList
                    items={products}
                    columns={columns}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.multiple}
                    selection={selection}
                    checkboxVisibility={CheckboxVisibility.always}
                    checkboxCellClassName="checkbox-square"   
                                    
                />
           <DialogFooter>
                <PrimaryButton onClick={onSave} text="Add Products" />
                <DefaultButton onClick={props.hideDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>
    );
    
};




export default ProductPicker;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/productPicker/ProductPicker.tsx